import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  useDispatch,
  Form,
  connect,
} from "../../../atoms/DependencyHelper";
import HomeAddressForm from "../../../atoms/newLineForms/creditCheckForms/homeAddressForm/HomeAddressForm";
import ContentSearchBox from "../../../atoms/contentSearchBox/ContentSearchBox";
import HomeDetailsInfo from "../../../atoms/newLineForms/creditCheckDetails/homeDetailsInfo/HomeDetailsInfo";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import {
  imagePrefix,
  numRegEx,
  streetNameRegEx,
  addAutoSlashToPeriod,
  checkYearAndMonthFormat,
  getValueLabel,
} from "../../../../utils/helperServices";
import {
  UNIT,
  BUSINESS,
  STREET_NO,
  ROUTE,
  SUBURB,
  MINOR_SUBURB,
  PROVINCE,
  POST_STREET,
  TOWN,
  CITY,
  POST_BOX,
  STREET_ADDR,
  BUILDING_ADDR,
} from "../../../../config/constants";
import formStyles from "../CheckoutCreditCheck.module.scss";
import errorMessages from "../../../../config/errorMessages";
import Image from "../../../atoms/image/image";
import * as Analytics from "../../../../services/analyticsUtag";
import { SET_CREDIT_CHECK_HOME_DATA } from "../../../../Redux/actionTypes/index";
import { journeyType } from "../../../../context/checkout-journey-context";
const analyticsTags = [
  "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type",
];

const HomeDetails = ({
  customerStatus,
  homeDetailsData,
  addressTypes,
  statesTypes,
  onFormSubmit,
  currentJourneyType,
  doCreditCheckDisable,
}) => {
  const [analytics, setAnalytics] = useState(false);
  const [displayEditMode, setDisplayEditMode] = useState(
    homeDetailsData ? false : true
  );
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [finalAddress, setFinalAddress] = useState([]);
  const addressTypesOptions = addressTypes ? addressTypes : [];
  const stateTypesOptions = statesTypes ? statesTypes : [];
  const [residenceTypes, setResidenceTypes] = useState([
    {
      id: "W",
      name: "I’m the owner",
    },
    {
      id: "R",
      name: "I rent here",
    },
    {
      id: "O",
      name: "Other",
    },
  ]);
  const [monthString, setMonthString] = useState("months");
  const [yearString, setYearString] = useState("years");

  const RESIDENTIAL_ADDRESS_TYPE =
    addressTypesOptions && addressTypesOptions.length > 0
      ? addressTypesOptions[0].id
      : "";

  const cloneOfErrorMessages = JSON.parse(
    JSON.stringify(errorMessages.creditCheckout.errors.home)
  );

  const dispatch = useDispatch();

  useEffect(() => {
    addressSearchResultMap();
  }, [finalAddress]);

  useEffect(() => {
    if (addressTypesOptions.length > 0) {
      fieldValues.homeDetails.addressType = RESIDENTIAL_ADDRESS_TYPE;

      setState({
        ...state,
        fieldValues,
      });
    }
  }, [addressTypesOptions]);

  useEffect(() => {
    if (stateTypesOptions.length > 0) {
      fieldValues.homeDetails.province = stateTypesOptions[0].id;

      setState({
        ...state,
        fieldValues,
      });
    }
  }, [stateTypesOptions]);

  const getProvinceValue = (name) => {
    var finalID = stateTypesOptions.filter((item) => item.code == name);
    if (finalID && finalID[0] && finalID[0].id) {
      return finalID[0].id;
    }
  };

  useEffect(() => {
    if (homeDetailsData) {
      fieldValues.homeDetails.addressName = homeDetailsData.addressName;
      fieldValues.homeDetails.addressType = homeDetailsData.addressType;
      fieldValues.homeDetails.unitNo = homeDetailsData.unitNo;
      fieldValues.homeDetails.complexName = homeDetailsData.complexName;
      fieldValues.homeDetails.streetNo = homeDetailsData.streetNo;
      fieldValues.homeDetails.streetName = homeDetailsData.streetName;
      fieldValues.homeDetails.suburb = homeDetailsData.suburb;
      fieldValues.homeDetails.postalCode = homeDetailsData.postalCode;
      fieldValues.homeDetails.town = homeDetailsData.town;
      fieldValues.homeDetails.province = homeDetailsData.province;
      fieldValues.homeDetails.instructions = homeDetailsData.instructions;
      fieldValues.homeDetails.residence = homeDetailsData.residence;
      fieldValues.homeDetails.currentAddressYears =
        homeDetailsData.currentAddressYears;
      fieldValues.homeDetails.currentAddressMonths =
        homeDetailsData.currentAddressMonths;
      fieldValues.homeDetails.previousAddressYears =
        homeDetailsData.previousAddressYears;
      fieldValues.homeDetails.previousAddressMonths =
        homeDetailsData.previousAddressMonths;

      errorStatus.homeDetails = checkFormError("homeDetails");

      if (errorStatus.homeDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    }
  }, [homeDetailsData]);

  const [state, setState] = useState({
    validationsOn: {
      homeDetails: true,
    },
    errorStatus: {
      homeDetails: true,
    },
    validations: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: true,
        suburb: true,
        postalCode: true,
        town: true,
        province: true,
        instructions: false,
        residence: currentJourneyType != journeyType.addLine ? true : false,
        currentAddressYears:
          currentJourneyType != journeyType.addLine ? true : false,
        currentAddressMonths:
          currentJourneyType != journeyType.addLine ? true : false,
        previousAddressYears:
          currentJourneyType != journeyType.addLine ? true : false,
        previousAddressMonths:
          currentJourneyType != journeyType.addLine ? true : false,
        currentAddressPeriod:
          currentJourneyType != journeyType.addLine ? true : false,
        previousAddressPeriod:
          currentJourneyType != journeyType.addLine ? true : false,
      },
    },
    fieldErrors: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        residence: false,
        currentAddressPeriod: false,
        previousAddressPeriod: false,
      },
      fail: false,
    },
    fieldValues: {
      homeDetails: {
        addressName: "",
        addressType: "",
        unitNo: "",
        complexName: "",
        streetNo: "",
        streetName: "",
        suburb: "",
        postalCode: "",
        town: "",
        province: "",
        instructions: "",
        residence: "",
        currentAddressYears: "",
        currentAddressMonths: "",
        previousAddressYears: "",
        previousAddressMonths: "",
      },
    },
    readOnlyValues: {
      homeDetails: {
        addressName: false,
        addressType: false,
        unitNo: false,
        complexName: false,
        streetNo: false,
        streetName: false,
        suburb: false,
        postalCode: false,
        town: false,
        province: false,
        instructions: false,
        residence: false,
        currentAddressYears: false,
        currentAddressMonths: false,
        previousAddressYears: false,
        previousAddressMonths: false,
      },
    },
    fieldErrorsMessage: cloneOfErrorMessages,
  });

  const {
    validationsOn,
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    readOnlyValues,
    fieldErrorsMessage,
  } = state;

  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;

    //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onChange event.
    if (name === "currentAddressYears" || name === "previousAddressYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, yearString);
    } else if (
      name === "previousAddressMonths" ||
      name === "currentAddressMonths"
    ) {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, monthString);
    } else {
      fieldValues[form][name] = value;
    }

    setState({
      ...state,
      fieldValues,
    });
  };

  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    event.persist();

    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "visitor_login_status",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: address details`,
      });
      setAnalytics(true);
    }
    await updateFieldValues(event, val, form);
  };

  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */
  const handleReset = async (name, form) => {
    //TBD
  };

  const handleFocus = async (event, form) => {
    event.persist();
    const name = event.target.name;
    const value = event.target.value;
    //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onFocus event.
    if (name === "currentAddressYears" || name === "previousAddressYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, yearString);
    } else if (
      name === "previousAddressMonths" ||
      name === "currentAddressMonths"
    ) {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, monthString);
    }
    setState({
      ...state,
      fieldValues,
    });
  };

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    event.persist();
    const name = event.target.name;
    const value = val ? val : event.target.value;
    await fieldValidationCheck(event, val, form);
    //call addAutoSlashToPeriod function to reformat the YEAR and MONTH values on the onBlur event.
    if (name === "currentAddressYears" || name === "previousAddressYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, true, yearString);
    } else if (
      name === "previousAddressMonths" ||
      name === "currentAddressMonths"
    ) {
      fieldValues[form][name] = addAutoSlashToPeriod(value, true, monthString);
    }
    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
      fieldValues,
    });

    if (fieldErrors.fail) {
      setSubmitDisabled(true);
      let errMsg = fieldErrorsMessage[form][name];
      inlineAnalytics(errMsg);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Check input field validation
   *
   * @usage Set the state of form fieldErrors, fieldErrorsMessage
   */
  const fieldValidationCheck = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;

    switch (name) {
      case "unitNo":
        if (value.length > 0) {
          fieldErrors[form].unitNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].unitNo) {
            fieldErrorsMessage[form].unitNo =
              errorMessages.creditCheckout.homeDetails.unitNo.onlyNumber;
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].unitNo) {
            fieldErrors[form].unitNo = true;
          } else {
            fieldErrors[form].unitNo = false;
          }

          fieldErrorsMessage[form].unitNo =
            errorMessages.creditCheckout.errors.home.homeDetails.unitNo;
        }
        fieldErrors.fail = fieldErrors[form].unitNo;
        break;

      case "streetNo":
        if (value.length > 0) {
          fieldErrors[form].streetNo = numRegEx.test(value) ? false : true;
          if (fieldErrors[form].streetNo) {
            fieldErrorsMessage[form].streetNo =
              errorMessages.creditCheckout.homeDetails.streetNo.onlyValid;
          }
        } else {
          if (state.validationsOn[form] && state.validations[form].streetNo) {
            fieldErrors[form].streetNo = true;
          } else {
            fieldErrors[form].streetNo = false;
          }

          fieldErrorsMessage[form].streetNo =
            errorMessages.creditCheckout.errors.home.homeDetails.streetNo;
        }
        fieldErrors.fail = fieldErrors[form].streetNo;

        break;

      case "streetName":
        if (state.validationsOn[form] && state.validations[form].streetName) {
          if (value.length > 0) {
            if (!streetNameRegEx.test(value)) {
              fieldErrors[form].streetName = true;
              fieldErrorsMessage[form].streetName =
                errorMessages.creditCheckout.homeDetails.streetName.onlyValid;
            } else {
              fieldErrors[form].streetName = false;
            }
          } else {
            fieldErrors[form].streetName = true;
            fieldErrorsMessage[form].streetName =
              errorMessages.creditCheckout.errors.home.homeDetails.streetName;
          }
          fieldErrors.fail = fieldErrors[form].streetName;
        } else {
          fieldErrors[form].streetName = false;
        }
        break;

      case "suburb":
        if (state.validationsOn[form] && state.validations[form].suburb) {
          fieldErrors[form].suburb = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].suburb;
        } else {
          fieldErrors[form].suburb = false;
        }
        break;

      case "town":
        if (state.validationsOn[form] && state.validations[form].town) {
          fieldErrors[form].town = value.length == 0 ? true : false;
          fieldErrors.fail = fieldErrors[form].town;
        } else {
          fieldErrors[form].town = false;
        }
        break;

      case "postalCode":
        if (state.validationsOn[form] && state.validations[form].postalCode) {
          if (value.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.creditCheckout.homeDetails.postalCode.onlyNumber;
            } else if (value.length < 4) {
              fieldErrors[form].postalCode = true;
              fieldErrorsMessage[form].postalCode =
                errorMessages.creditCheckout.homeDetails.postalCode.onlyValid;
            } else {
              fieldErrors[form].postalCode = false;
            }
          } else {
            fieldErrors[form].postalCode = true;
            fieldErrorsMessage[form].postalCode =
              errorMessages.creditCheckout.errors.home.homeDetails.postalCode;
          }
          fieldErrors.fail = fieldErrors[form].postalCode;
        } else {
          fieldErrors[form].postalCode = false;
        }
        break;

      case "province":
        if (state.validationsOn[form] && state.validations[form].province) {
          fieldErrors[form].province = value == "" ? true : false;
          if (fieldErrors[form].province) {
            fieldErrorsMessage[form].province =
              errorMessages.creditCheckout.errors.home.homeDetails.province;
          }
          fieldErrors.fail = fieldErrors[form].province;
        } else {
          fieldErrors[form].province = false;
        }
        break;

      case "residence":
        if (state.validationsOn[form] && state.validations[form].residence) {
          fieldErrors[form].residence = value == "" ? true : false;
          if (fieldErrors[form].residence) {
            fieldErrorsMessage[form].residence =
              errorMessages.creditCheckout.errors.home.homeDetails.residence;
          }
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors.fail = fieldErrors[form].residence;
          }
        } else {
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors[form].residence = false;
          }
        }
        break;

      case "currentAddressYears":
      case "currentAddressMonths":
        if (
          state.validationsOn[form] &&
          (state.validations[form].currentAddressYears ||
            state.validations[form].currentAddressMonths)
        ) {
          if (value.length > 0) {
            if (
              checkYearAndMonthFormat(
                fieldValues[form].currentAddressYears,
                fieldValues[form].currentAddressMonths,
                true
              )
            ) {
              fieldErrors[form].currentAddressPeriod = true;
              fieldErrorsMessage[form].currentAddressPeriod =
                errorMessages.creditCheckout.homeDetails.currentAddressPeriod.onlyValid;
            } else {
              fieldErrors[form].currentAddressPeriod = false;
            }
          } else {
            fieldErrors[form].currentAddressPeriod = true;
            fieldErrorsMessage[form].currentAddressPeriod =
              errorMessages.creditCheckout.errors.home.homeDetails.currentAddressPeriod;
          }
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors.fail = fieldErrors[form].currentAddressPeriod;
          }
        } else {
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors[form].currentAddressPeriod = false;
          }
        }
        break;

      case "previousAddressYears":
      case "previousAddressMonths":
        if (
          state.validationsOn[form] &&
          (state.validations[form].previousAddressYears ||
            state.validations[form].previousAddressMonths)
        ) {
          if (value.length > 0) {
            if (
              checkYearAndMonthFormat(
                fieldValues[form].previousAddressYears,
                fieldValues[form].previousAddressMonths,
                false
              )
            ) {
              fieldErrors[form].previousAddressPeriod = true;
              fieldErrorsMessage[form].previousAddressPeriod =
                errorMessages.creditCheckout.homeDetails.previousAddressPeriod.onlyValid;
            } else {
              fieldErrors[form].previousAddressPeriod = false;
            }
          } else {
            fieldErrors[form].previousAddressPeriod = true;
            fieldErrorsMessage[form].previousAddressPeriod =
              errorMessages.creditCheckout.errors.home.homeDetails.previousAddressPeriod;
          }
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors.fail = fieldErrors[form].previousAddressPeriod;
          }
        } else {
          if (currentJourneyType != journeyType.addLine) {
            fieldErrors[form].previousAddressPeriod = false;
          }
        }
        break;
    }

    setState({
      ...state,
      fieldErrors,
      fieldErrorsMessage,
    });
  };

  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */
  const inlineAnalytics = (message) => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "error",
      page_errors: message,
      page_form_name: `checkout: credit check ${customerStatus}: address details`,
      page_error_type: "form",
    });
  };

  /**
   * Set the on page edit
   *
   * @call on edit event
   */
  const setAnalyticsOnPageEdit = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: edit address details`,
    });
  };

  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */
  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);
    if (currentJourneyType == journeyType.addLine) {
      entries[11][1] = false;
      entries[12][1] = false;
      entries[13][1] = false;
    }
    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */
  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);

    for (const err of errValues) {
      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }

    setSubmitDisabled(false);
  }

  const addressSearchResultMap = async () => {
    const localityType = finalAddress.address_components;
    if (localityType && localityType.length > 0) {
      await mapAddressSearchData(localityType);

      errorStatus.homeDetails = await checkFormError("homeDetails");

      setState({
        ...state,
        errorStatus,
      });

      if (errorStatus.homeDetails) {
        setSubmitDisabled(true);
      } else {
        checkErrorStatus();
      }
    }
  };

  /**
   * Set the on page submit
   *
   * @call on next button click
   */
  const setAnalyticsOnNextButton = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: address details: next`,
    });
  };

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["homeDetails"]) {
      submitForm();
    }
  };

  /**
   *
   * @usage submit the form with request payload
   */
  const submitForm = async () => {
    let addressType, province;
    if (fieldValues.homeDetails.complexName) {
      addressType = BUILDING_ADDR;
    } else {
      addressType = STREET_ADDR;
    }
    province = getValueLabel(
      state.fieldValues["homeDetails"]["province"],
      stateTypesOptions
    );
    dispatch({
      type: SET_CREDIT_CHECK_HOME_DATA,
      payload: {
        ...state.fieldValues["homeDetails"],
        addressType: addressType,
        provinceName: province,
      },
    });
    onFormSubmit(true);
    setDisplayEditMode(false);
    doCreditCheckDisable("homeDetails", false);

    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "success",
      page_form_name: `checkout: credit check: ${customerStatus}: address details`,
    });
  };

  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */
  const clickOnEditButton = () => {
    setDisplayEditMode(true);
    doCreditCheckDisable("homeDetails", true);
    setAnalyticsOnPageEdit();
  };

  const mapAddressSearchData = async (localityType) => {
    readOnlyValues.homeDetails.postalCode = false;

    fieldValues.homeDetails.unitNo = "";
    fieldValues.homeDetails.complexName = "";
    fieldValues.homeDetails.streetNo = "";
    fieldValues.homeDetails.streetName = "";
    fieldValues.homeDetails.suburb = "";
    fieldValues.homeDetails.province = "";
    fieldValues.homeDetails.town = "";
    fieldValues.homeDetails.postalCode = "";
    fieldValues.homeDetails.residence = "";
    fieldValues.homeDetails.currentAddressYears = "";
    fieldValues.homeDetails.currentAddressMonths = "";
    fieldValues.homeDetails.previousAddressYears = "";
    fieldValues.homeDetails.previousAddressMonths = "";

    fieldErrors.homeDetails.unitNo = false;
    fieldErrors.homeDetails.complexName = false;
    fieldErrors.homeDetails.streetNo = false;
    fieldErrors.homeDetails.streetName = false;
    fieldErrors.homeDetails.suburb = false;
    fieldErrors.homeDetails.province = false;
    fieldErrors.homeDetails.town = false;
    fieldErrors.homeDetails.postalCode = false;
    fieldErrors.homeDetails.residence = false;
    fieldErrors.homeDetails.currentAddressPeriod = false;
    fieldErrors.homeDetails.previousAddressPeriod = false;

    for (let i = 0; i < localityType.length; i++) {
      if (localityType[i].administrative_type == UNIT) {
        if (localityType[i].long_name) {
          fieldValues.homeDetails.unitNo = localityType[i].long_name;
        }
      }

      if (localityType[i].administrative_type == BUSINESS) {
        fieldValues.homeDetails.complexName = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == STREET_NO) {
        fieldValues.homeDetails.streetNo = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == ROUTE) {
        fieldValues.homeDetails.streetName = localityType[i].long_name;
      }

      if (
        localityType[i].administrative_type == SUBURB ||
        localityType[i].administrative_type == MINOR_SUBURB
      ) {
        fieldValues.homeDetails.suburb = localityType[i].long_name;
      }

      if (localityType[i].administrative_type == PROVINCE) {
        fieldValues.homeDetails.province = getProvinceValue(
          localityType[i].long_name
        );
      }

      if (
        localityType[i].administrative_type == TOWN ||
        localityType[i].administrative_type == CITY
      ) {
        fieldValues.homeDetails.town = localityType[i].long_name;
      }

      if (
        localityType[i].administrative_type == POST_STREET ||
        localityType[i].administrative_type == POST_BOX
      ) {
        if (localityType[i].long_name.length > 0) {
          readOnlyValues.homeDetails.postalCode = true;
        }
        fieldValues.homeDetails.postalCode = localityType[i].long_name;
      }
    }

    setState({
      ...state,
      readOnlyValues,
      fieldValues,
      fieldErrors,
    });
  };

  return (
    <>
      <CustomContainer
        className={`${formStyles["container"]}`}
        id="home-details"
      >
        <CustomContainer className={formStyles["form-heading"]}>
          {displayEditMode ? (
            <Image
              img_path={`${imagePrefix}/assets/images/icon-home.svg`}
              img_alt="section"
              className={formStyles["section-icon"]}
            />
          ) : (
            <Image
              img_path={`${imagePrefix}/assets/images/success-circle_small.svg`}
              img_alt="succes"
              className={formStyles["section-success-icon"]}
            />
          )}
          Home address
          {displayEditMode ? (
            <CustomContainer className={formStyles["section-numbers"]}>
              {currentJourneyType != journeyType.addLine
                ? "Section 4 of 7"
                : "Section 3 of 5"}
            </CustomContainer>
          ) : (
            <CustomContainer className={formStyles["section-numbers"]}>
              <a onClick={() => clickOnEditButton()}>
                <Image
                  img_path={`${imagePrefix}/assets/images/blog.svg`}
                  img_alt="edit"
                />
                <span>Edit details</span>
              </a>
            </CustomContainer>
          )}
        </CustomContainer>
        <hr></hr>
        {!displayEditMode ? (
          <HomeDetailsInfo
            data={homeDetailsData}
            stateTypesOptions={stateTypesOptions}
            residenceTypes={residenceTypes}
            currentJourneyType={currentJourneyType}
          />
        ) : (
          <CustomContainer className={formStyles["pt-2"]}>
            <CustomContainer className={"d-none " + formStyles["search-wrapper"]}>
              <ContentSearchBox
                className={formStyles["search-wrapper__input"]}
                placeholderText="Search for your address"
                icon="blue"
                variant="address-search"
                setFinalAddress={setFinalAddress}
                pageName={`checkout: credit check: ${customerStatus}`}
                analyticFormName="address details"
              ></ContentSearchBox>
            </CustomContainer>
            <Form
              noValidate
              id="checkout-credit-home-address-form"
              onSubmit={handleSubmit}
            >
              <HomeAddressForm
                formName={"homeDetails"}
                fieldValues={state.fieldValues["homeDetails"]}
                fieldErrors={state.fieldErrors["homeDetails"]}
                fieldErrorsMessage={state.fieldErrorsMessage["homeDetails"]}
                readOnlyValues={state.readOnlyValues["homeDetails"]}
                stateTypesOptions={stateTypesOptions}
                residenceTypes={residenceTypes}
                onChangeHandler={handleChange}
                onResetHandler={handleReset}
                currentJourneyType={currentJourneyType}
                onBlurHandler={handleBlur}
                onFocusHandler={handleFocus}
              ></HomeAddressForm>
              <CustomContainer className={formStyles["button-wrapper"]}>
                <CTAButton
                  type="submit"
                  variant="solid grey"
                  disabled={submitDisabled}
                  className={formStyles["button"]}
                  id="checkout-credit-check-home-address-submit"
                >
                  Next
                </CTAButton>
              </CustomContainer>
            </Form>
          </CustomContainer>
        )}
      </CustomContainer>
    </>
  );
};

HomeDetails.propTypes = {
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    homeDetailsData: state.creditCheckDetails.homeDetails,
  };
};

export default connect(mapStateToProps)(HomeDetails);
